module.exports = __webpack_public_path__ + "static/media/mulan.d44b9504.jpg";